var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 35.0001L33.9626 20.8376C35.4279 19.3722 36.2511 17.3848 36.2511 15.3126C36.2511 13.2403 35.4279 11.2529 33.9626 9.78755C32.4972 8.32223 30.5098 7.49902 28.4376 7.49902C26.3653 7.49902 24.3779 8.32223 22.9126 9.78755L20.0001 12.5001L17.0876 9.78755C15.6222 8.32223 13.6348 7.49902 11.5626 7.49902C9.49028 7.49902 7.50287 8.32223 6.03755 9.78755C4.57223 11.2529 3.74902 13.2403 3.74902 15.3126C3.74902 17.3848 4.57223 19.3722 6.03755 20.8376L20.0001 35.0001Z",
    stroke: "#D849B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishList);
export default __webpack_public_path__ + "static/media/WishList.fc14f71c03b1ae1b3ac57abe03aec08c.svg";
export { ForwardRef as ReactComponent };